//PDP media gallery

pdpMediaSlider();
function pdpMediaSlider() {
  $('.media-gallery-wrapper').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $('.media-gallery-nav .paging-info').text(i + ' of ' + slick.slideCount);
    
  });

  $('.media-gallery-wrapper').on('init', function(event, slick){
    // after slick intialisation show 'Tap to zoom'
    $('.count-container').addClass('is-visible');

    // after slick intialisation show video buttons
    $('.play-video').removeClass('hidden');
  })

  $('.media-gallery-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: true,
    adaptiveHeight: true,
    asNavFor: '.media-gallery-nav-wrapper',
      responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1.1,
          fade: false,
          infinite: false,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.media-gallery-nav-wrapper').slick({
    lazyLoad: 'ondemand',
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.media-gallery-wrapper',
    arrows: true,
    dots: false,
    swipeToSlide: true,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: '30px',
    accessibility: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          centerPadding: '50px',
        }
      }
    ]
  });

  //Fix centerMode bug when items less than slidesToShow
  if($('.media-gallery-nav-wrapper .media-gallery-nav__thumbnails').length <= 5){
    $('.media-gallery-nav-wrapper').addClass('center-track');
  }

  if(!$('.product-form__variants').length) {
    return;
  }

  var imageID = $('.product-form__variants option:selected').attr("data-image-id");

  if(imageID) {
    var slideIndex = $('.media-gallery-wrapper').find('[data-image-id="' + imageID + '"]').parent().attr('data-slick-index');
    $('.media-gallery-wrapper').slick('slickGoTo', slideIndex, true);
  }
}

$.fn.isOnScreen = function() {
    var win = $(window);
    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

$(document).ready(function() {
  $(window).scroll(function() {
      if (($(".product-form__submit").isOnScreen())|| $("#shopify-section-footer").isOnScreen()) {
        $( ".sticky-add-to-cart" ).slideUp("fast");
      } else {
        $( ".sticky-add-to-cart" ).slideDown("fast");
      }
  }).trigger('scroll');
});